exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/list-req-no-freelancer/list-req-no-freelancer.component.css
// module id = ../../../../../src/app/list-req-no-freelancer/list-req-no-freelancer.component.css
// module chunks = main